// Links between parts and the service lines (services/{id}) they are for.
// Keep isOpenServiceLine in sync with skyway-functions parts/autoApprove.js.

// A line is open until it is completed or declined (same test as ServicesBlade).
export const isOpenServiceLine = (line) => !!line && line.status !== 'complete' && !line.declined;

// Why a part needs a reviewer's attention, given its linked line (or undefined):
//   'none'   — requested as "Not for a service line"
//   'closed' — its line is complete, declined, or gone
//   null     — linked to an open line, already ordered, or a part from before
//              serviceId existed
// Only parts not yet ordered are flagged: once a part is ordered its line
// closing is the normal end of the job, not a warning.
const UNORDERED_PART_STATUSES = ['pending', 'approved'];

export const serviceLineIssue = (part, line) => {
  if (!part || !Object.prototype.hasOwnProperty.call(part, 'serviceId')) return null;
  if (!UNORDERED_PART_STATUSES.includes(part.status)) return null;
  if (!part.serviceId) return 'none';
  return isOpenServiceLine(line) ? null : 'closed';
};

export const SERVICE_LINE_ISSUE_TEXT = {
  none: 'No service line',
  closed: 'Service line closed',
};

// Text for a confirm() before approving parts with a service-line issue, or ''
// when none of them has one. Parts carry `serviceLineIssue` from
// Store.attachServiceLineIssues.
export const serviceLineConfirmText = (parts) => {
  const flagged = parts.filter((p) => p.serviceLineIssue);
  if (!flagged.length) return '';
  const names = flagged.slice(0, 5).map((p) => `• ${p.name || 'Unnamed part'} (${SERVICE_LINE_ISSUE_TEXT[p.serviceLineIssue]})`);
  if (flagged.length > 5) names.push(`• and ${flagged.length - 5} more`);
  return `${flagged.length} of the selected parts ${flagged.length === 1 ? 'is' : 'are'} not tied to an open service line:\n\n${names.join('\n')}\n\nThe work may not happen. Approve anyway?`;
};
